<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">
        
        <!-- Page Header -->
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">Settings</h3>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Settings Tabs -->
        <ul class="nav nav-tabs menu-tabs">
          <li class="nav-item">
            <router-link class="nav-link" to="/settings/profile">
              <i class="fas fa-user mr-2"></i>Profile
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/settings/security">
              <i class="fas fa-lock mr-2"></i>Security
            </router-link>
          </li>
          <li class="nav-item active">
            <router-link class="nav-link" to="/settings/preferences">
              <i class="fas fa-bell mr-2"></i>Preferences
            </router-link>
          </li>
        </ul>

        <!-- Preferences Form -->
        <div>
          <form @submit.prevent="updatePreferences">
            <div class="row">
              <div class="col-lg-9">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title mb-0">Notification Preferences</h5>
                  </div>
                  <div class="card-body">
                    <table class="table table-hover mb-0">
                      <thead style="background-color: ghostwhite">
                        <tr class="text-left">
                          <th class="text-left">Preference</th>
                          <th class="text-right">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="text-left">
                          <td class="text-left">
                            <strong>Email Notifications</strong>
                            <p class="text-muted mb-0 small">Receive email notifications about appointments and invoices</p>
                          </td>
                          <td class="text-right">
                            <label class="toggle-switch">
                              <input type="checkbox" v-model="preferences.emailNotifications">
                              <span class="slider round"></span>
                            </label>
                          </td>
                        </tr>
                        <tr class="text-left">
                          <td class="text-left">
                            <strong>SMS Notifications</strong>
                            <p class="text-muted mb-0 small">Receive SMS reminders for appointments</p>
                          </td>
                          <td class="text-right">
                            <label class="toggle-switch">
                              <input type="checkbox" v-model="preferences.smsNotifications">
                              <span class="slider round"></span>
                            </label>
                          </td>
                        </tr>
                        <tr class="text-left">
                          <td class="text-left">
                            <strong>Marketing Communications</strong>
                            <p class="text-muted mb-0 small">Receive promotional offers and updates</p>
                          </td>
                          <td class="text-right">
                            <label class="toggle-switch">
                              <input type="checkbox" v-model="customer.receiveMarketingEmails">
                              <span class="slider round"></span>
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-footer text-right">
                    <button 
                      type="submit" 
                      class="btn btn-primary"
                      :disabled="isUpdatingPreferences"
                    >
                      <i class="fas fa-save mr-2"></i>
                      {{ isUpdatingPreferences ? 'Saving...' : 'Save Preferences' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import customerService from "../../service/customer.service";

export default {
  name: "preferences-settings",
  data() {
    return {
      customer: {
        receiveMarketingEmails: false,
        receiveMarketingSms: false
      },
      preferences: {
        emailNotifications: true,
        smsNotifications: true
      },
      isUpdatingPreferences: false,
      mid: null,
      customerId: null
    };
  },
  mounted() {
    this.retrieveUser();
    this.retrieveCustomer();
  },
  methods: {
    retrieveUser() {
      this.mid = localStorage.getItem('mid');
      this.customerId = localStorage.getItem('actorId');
    },

    retrieveCustomer() {
      if (!this.mid || !this.customerId) {
        console.error('Missing merchant ID or customer ID');
        return;
      }

      customerService.findById(this.mid, this.customerId)
        .then(response => {
          if (response.data.success) {
            const data = response.data.data;
            this.customer.receiveMarketingEmails = data.receiveMarketingEmails || false;
            this.customer.receiveMarketingSms = data.receiveMarketingSms || false;
            
            this.preferences.emailNotifications = data.receiveMarketingEmails || false;
            this.preferences.smsNotifications = data.receiveMarketingSms || false;
          }
        })
        .catch(error => {
          console.error('Error retrieving customer:', error);
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Failed to load preferences'
          });
        });
    },

    updatePreferences(event) {
      event.preventDefault();
      
      this.isUpdatingPreferences = true;
      
      this.customer.receiveMarketingEmails = this.preferences.emailNotifications;
      this.customer.receiveMarketingSms = this.preferences.smsNotifications;
      
      const updateData = {
        receiveMarketingEmails: this.customer.receiveMarketingEmails,
        receiveMarketingSms: this.customer.receiveMarketingSms
      };

      customerService.update(this.mid, this.customerId, updateData)
        .then(response => {
          this.isUpdatingPreferences = false;
          
          if (response.data.success) {
            this.$swal({
              icon: 'success',
              title: 'Success',
              text: 'Preferences updated successfully'
            });
          } else {
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: response.data.narrative || 'Failed to update preferences'
            });
          }
        })
        .catch(error => {
          this.isUpdatingPreferences = false;
          console.error('Error updating preferences:', error);
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update preferences'
          });
        });
    }
  }
};
</script>

<style scoped>
.card-title {
  color: #667eea;
  font-weight: 600;
}

.table td {
  vertical-align: middle;
}

.text-muted.small {
  font-size: 0.875rem;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #20c997;
}

input:focus + .slider {
  box-shadow: 0 0 1px #20c997;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/PreferencesSettings.vue